<!--
 * @Author: zly
 * @Date: 2021-08-06 09:16:49
 * @LastEditTime: 2021-12-22 15:51:42
 * @LastEditors: zly
 * @Description:
-->
<!------
  @description 头部信息栏
  @methods 无
  @param 无
  @special 空
------>
<template>
  <div class="nav-bar">
    <div class="top-message ell_one">
      欢迎您,{{userName}}!
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
export default {
  name: 'navBar',
  data () {
    return {}
  },
  computed: {
    userName () {
      return Cookies.get('username_shop')
    }
  },
  created () {},
  methods: {}
}
</script>

<style scoped lang="scss">
.nav-bar {
  width: 100%;
  height: 30px;
  line-height: 30px;
  background: #D8D8D8;
  z-index: 1000;
  .top-message {
    width: 1190px;
    margin: 0 auto;
    color: #000;
    padding-left: 220px;
    font-size: 12px;
    font-family: PingFangSC, PingFangSC-Regular;
  }
}
</style>
